// https://github.com/Akryum/v-tooltip
import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
